<template>
  <transition name="dialog">
    <yb-modal
      v-if="show"
      :show="show"
      title="Generated Prompt"
      type="form"
      dialog-classes="min-w-[600px] max-w-[75%] max-h-[75vh] mx-auto"
      @close="closeGeneratedPrompt"
      click-lock
    >
      <div class="flex flex-col justify-center h-full">
        <div class="relative flex-grow overflow-auto border border-gray-300 rounded-md my-auto pb-4">
          <yb-icon
            v-yb-clipboard:text="formattedMessage"
            icon="clipboard"
            class="h-4 w-4 cursor-pointer absolute top-1 right-6 z-10 text-gray-600 hover:text-gray-800"
            clipboard-label="Generated Prompt"
          />
          <div class="py-6 px-2 box-border h-full">
            <yb-markdown class="text-sm" :source="formattedMessage" />
          </div>
        </div>
      </div>
    </yb-modal>
</transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    activeTabKey() {
      return this.$store.get('query-editor/settings@tab')
    },
    activeTabSettings() {
      const tabs = this.$store.get('query-editor/settings@tabs')
      return tabs.find(tab => tab.key === this.activeTabKey)?.settings || {}
    },
    copilotGeneratedPrompt: {
      get() {
        return this.activeTabSettings.copilotGeneratedPrompt || ''
      }
    },
    formattedMessage() {
      return this.copilotGeneratedPrompt
    },
  },
  methods: {
    closeGeneratedPrompt() {
      this.$emit('update:show', false)
    }
  }
}
</script>
